import { initStore } from '@/lib/store';
import type { StoreWithSelectors } from '@/lib/store';
import { WalletInfo } from '@/api/wallet/wallet';

interface BaseState {
    walletInfo: WalletInfo;
    setWalletInfo: (walletInfo: WalletInfo) => void;
    updateUserWalletInfo: (diamond: number) => void;
}

let useWalletStore: StoreWithSelectors<BaseState>;

const initialState = (set: (updater: (state: BaseState) => Partial<BaseState>) => void) => ({
    walletInfo: {
        user_id: '',
        user_diamond: 0,
        cp_diamond: 0
    },
    setWalletInfo: (walletInfo: WalletInfo) => {
        set(() => ({
            walletInfo
        }));
    },
    updateUserWalletInfo: (diamond: number) => {
        set(state => ({
            walletInfo: { ...state.walletInfo, user_diamond: state.walletInfo.user_diamond + diamond }
        }));
    }
});

const createWalletStore = () => {
    useWalletStore = initStore<BaseState>(initialState);
};

export { createWalletStore, useWalletStore };
